/* eslint-disable react/jsx-pascal-case */
import { ArrowCircleRight, Print } from '@mui/icons-material';
import { Chip, IconButton, Tooltip } from '@mui/material';
import ArgonTypography from 'components/ArgonTypography';
import { MRT_ShowHideColumnsButton, MRT_ToggleDensePaddingButton, MRT_ToggleFullScreenButton, MRT_ToggleGlobalFilterButton, MaterialReactTable } from 'material-react-table';
import { useMemo } from 'react';
import { Link } from 'react-router-dom';

const TabelPelaporan = ({ loading, data, baseUrl }) => {

    const columns = useMemo(() => ([
        {
            accessorKey: 'kode',
            header: 'Kode',
            size: 45,
            Cell: ({ cell }) => (
                <ArgonTypography
                    fontWeight={(cell.row.original.ket === 'PROGRAM' || cell.row.original.ket === 'KEGIATAN') && 'bold'}
                    fontSize="small"
                    variant="inherit"
                >
                    {cell.getValue()}
                </ArgonTypography>
            )
        },
        {
            accessorKey: 'uraian',
            header: 'Uraian',
            size: 500,
            Cell: ({ cell }) => (
                <>
                    <ArgonTypography
                        fontWeight={(cell.row.original.ket === 'PROGRAM' || cell.row.original.ket === 'KEGIATAN') && 'bold'}
                        fontSize="small"
                        variant="inherit"
                    // color={cell.row.original.ket === 'SubKegiatan' ? 'primary' : 'inherit'}
                    >
                        {cell.getValue()}
                    </ArgonTypography>
                    {
                        cell.row.original.ket === 'SUB KEGIATAN' ?
                            cell.row.original.terinput ? <Chip size='small' variant='outlined' label="Komponen Belanja sudah Terinput" color='success' /> : <Chip size='small' variant='outlined' label="Input Komponen Belanja belum Selesai" color='error' /> : ''

                    }
                    {
                        cell.row.original.ket === 'SUB KEGIATAN' &&
                        cell.row.original.melapor === false && <Chip size='small' variant='outlined' label="Realisasi belum dilaporkan" color='error' />
                    }
                </>
            )
        },
        {
            accessorKey: 'anggaran',
            header: 'Anggaran',
            Cell: ({ cell }) => (
                <ArgonTypography
                    fontWeight={(cell.row.original.ket === 'PROGRAM' || cell.row.original.ket === 'KEGIATAN') && 'bold'}
                    variant="inherit"
                    fontSize="small"
                >
                    {
                        cell.getValue()?.toLocaleString?.('id-ID', {
                            style: 'currency',
                            currency: 'IDR',
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                        })
                    }
                </ArgonTypography>
            )
        },
        {
            accessorKey: 'realisasi_keuangan',
            header: 'Realisasi Keuangan',
            Cell: ({ cell }) => (
                <ArgonTypography
                    fontWeight={(cell.row.original.ket === 'PROGRAM' || cell.row.original.ket === 'KEGIATAN') && 'bold'}
                    variant="inherit"
                    fontSize="small"
                >
                    {
                        cell.getValue()?.toLocaleString?.('id-ID', {
                            style: 'currency',
                            currency: 'IDR',
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                        })
                    } ({cell.row.original.realisasi_keuangan_persen.toFixed(2)}%)
                </ArgonTypography>
            )
        },
        {
            accessorKey: 'realisasi_fisik',
            header: 'Realisasi Fisik',
            Cell: ({ cell }) => (
                <ArgonTypography
                    fontWeight={(cell.row.original.ket === 'PROGRAM' || cell.row.original.ket === 'KEGIATAN') && 'bold'}
                    variant="inherit"
                    fontSize="small"
                >
                    {(cell.getValue()).toFixed(2)}%
                </ArgonTypography>
            )
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    ]), [data])

    return (
        <>
            <MaterialReactTable
                columns={columns}
                data={data}
                // enableExpanding
                // enableExpandAll
                muiTableHeadCellProps={{
                    sx: {
                        fontSize: '0.875rem !important',
                        color: 'text.main !important'
                    }
                }}
                muiTableFooterCellProps={{
                    sx: {
                        fontSize: '0.875rem !important',
                        color: 'text.main !important'
                    }
                }}
                muiTopToolbarProps={{
                    sx: { fontSize: '0.875rem' }
                }}
                initialState={{
                    // expanded: true
                }}
                enablePagination={false}
                enableColumnFilters={false}
                renderToolbarInternalActions={({ table }) => (
                    <>
                        <MRT_ToggleGlobalFilterButton table={table} color='text' />
                        <MRT_ShowHideColumnsButton table={table} color='text' />
                        <MRT_ToggleFullScreenButton table={table} color='text' />
                        <MRT_ToggleDensePaddingButton table={table} color='text' />
                        <Tooltip title="Print">
                            <IconButton onClick={() => window.print()}>
                                <Print />
                            </IconButton>
                        </Tooltip>
                    </>
                )}
                enableSorting={false}
                state={{
                    isLoading: loading,
                    showColumnFilters: false
                }}
                enableRowActions={true}
                positionActionsColumn='first'
                renderRowActions={({ row, table }) => (
                    row.original.ket === 'SUB KEGIATAN' &&
                    <Tooltip title="Rincian Belanja">
                        <IconButton
                            id="basic-button"
                            color='primary'
                            component={Link}
                            to={baseUrl + '/rincian-belanja'}
                            state={row.original}
                        >
                            <ArrowCircleRight fontSize='small' />
                        </IconButton>
                    </Tooltip>
                )}
                displayColumnDefOptions={{
                    'mrt-row-actions': {
                        header: 'Aksi', //change header text
                        size: 50, //make actions column wider
                        alignment: 'left'
                    },
                }}
            // onColumnFilterFnsChange={}
            // onColumnFiltersChange={}
            />
        </>
    )
}

export default TabelPelaporan